/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

// eslint-disable-next-line react/prop-types
export const AxesSVG = ({ selected }) => (
  selected ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6923_103442)">
        <path d="M15.3332 14.2153L7.99984 8.7718V0.666626M15.3332 14.2153L14.8752 11.9572M15.3332 14.2153L13.0419 14.6666M7.99984 0.666626L6.1665 2.47345M7.99984 0.666626L9.83317 2.47345M7.99984 8.77263L0.666504 14.2153M0.666504 14.2153L2.95858 14.6666M0.666504 14.2153L1.12524 11.9572" stroke="#3800EE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_6923_103442">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6923_103446)">
        <path d="M15.3332 14.2153L7.99984 8.7718V0.666626M15.3332 14.2153L14.8752 11.9572M15.3332 14.2153L13.0419 14.6666M7.99984 0.666626L6.1665 2.47345M7.99984 0.666626L9.83317 2.47345M7.99984 8.77263L0.666504 14.2153M0.666504 14.2153L2.95858 14.6666M0.666504 14.2153L1.12524 11.9572" stroke="#0E0F12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_6923_103446">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )

);
